<template>
  <div>
    <v-layout v-if="exists" row justify-flex-start align-center>
      <transition name="open">
        <v-icon v-if="hasChildren" class="expander" v-bind:class="{'expand-open': tree.expanded}"
                @click="toggleOpen">mdi-chevron-right</v-icon>
        <div v-else style="width: 24px"></div>
      </transition>
        <div v-if="isVisible" class="node-select" @click="toggle" :style="nodeStyle">
          <div class="node-icon">
            <v-icon v-if="ticked" small :style="nodeIconColor">mdi-check</v-icon>
            <v-icon v-if="indeterminate" small :style="nodeIconColor">mdi-minus</v-icon>
          </div>
        </div>
        <div class="note-item__maxwid" v-if="isVisible">{{`${tree.name} ${tree.isCourse ? tree.id : ''}`}}</div>
    </v-layout>

    <transition-group tag="div" name="fade" style="margin-left: 16px">
      <div v-for="child in children" :key="child.id">
        <tree-node :tree="child" v-bind="{openNode, tickNode}"></tree-node>
      </div>
    </transition-group>

  </div>
</template>

<script>
import Colors from '../../mixins/Colors'

export default {
  name: 'TreeNode',
  props: ['tree', 'openNode', 'tickNode'],
  mixins: [Colors],
  computed: {
    indeterminate () {
      return this.tree.ticked === undefined
    },
    exists () {
      return this.tree !== null
    },
    isVisible () {
      return this.tree.isVisible
    },
    hasChildren () {
      if (this.tree && this.tree.children) {
        return this.tree.children.length > 0
      } else {
        return false
      }
    },
    ticked: {
      get () {
        return this.tree.ticked
      },
      set (ticked) {
        this.tickNode(this.tree.id, ticked)
      }
    },
    children () {
      if (this.tree.expanded) {
        return this.tree.children
      } else {
        return []
      }
    },
    nodeStyle () {
      if (this.ticked) {
        return {
          backgroundColor: this.$vuetify.theme.accent,
          borderColor: this.$vuetify.theme.accent
        }
      }
    },
    nodeIconColor () {
      if (this.ticked) {
        return {
          color: this.getTextColor(this.$vuetify.theme.primary)
        }
      }
      return {}
    }
  },
  methods: {
    toggle () {
      if (this.tree.ticked === undefined) {
        this.tickNode(this.tree.id, true)
      } else {
        this.tickNode(this.tree.id, !this.tree.ticked)
      }
    },
    toggleOpen () {
      this.openNode(this.tree.id, !this.tree.expanded)
    },
    tickIt () {
      this.tickNode(this.tree.id, this.ticked)
    }
  }
}
</script>

<style scoped>
.expander {
  cursor: pointer;
}

.expand-open {
  transform: rotate(90deg);
}

.node-select {
  width: 18px;
  height: 18px;
  border: 1px solid gray;
  border-radius: 2px;
  display: inline-block;
  margin: 2px 8px 8px 4px;
}
.node-icon {
  margin-top: -3px
}

.note-item__maxwid {
  max-width: 400px;
}

/* rotating open icon */
.open-enter-active, .open-leave-active {
  transition: all 0.5s;
}
.open-enter, .open-leave-to {
    opacity: 1;
}

/* rows expand/collapse */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
  opaque: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
   opacity: 0;
   transform: translate(-64px, 0px)
}
</style>



// WEBPACK FOOTER //
// src/components/tree/TreeNode.vue